import { tracking } from '@iwoca/frontend-tracking-library';
import { IconCheckCircleFilled } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

import styles from './FundingStepActionButton.module.css';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';

export const FundingStepActionButton = ({
    status,
    handleFundingStepAction,
    actionMessage,
    pendingMessage,
    stepName
}: {
    status: TFundingRequirementsSteps['0']['status'];
    handleFundingStepAction: () => void;
    actionMessage: any;
    pendingMessage: any;
    stepName: any;
}) => {
    switch (status) {
        case 'COMPLETED':
            return (
                <div className={styles.actionIcon}>
                    <IconCheckCircleFilled
                        height="24"
                        width="24"
                        fill="rgba(0, 77, 51, 1)"
                        xlinkTitle="checked"
                    />
                </div>
            );
        case 'PENDING':
            return (
                <Button variant="primary" disabled>
                    {pendingMessage}
                </Button>
            );
        default:
            return (
                <Button
                    variant="primary"
                    onClick={() => {
                        tracking.ampli.fundingStepCtaClicked({
                            funding_step: stepName
                        });
                        handleFundingStepAction();
                    }}
                >
                    {actionMessage}
                </Button>
            );
    }
};
